export default "__VITE_ASSET__Cz6j3IWO__"